import React, { useEffect, useState } from "react";

export const Text = (props) => {
  const {
    className,
    bold,
    semiBold,
    medium,
    regular,
    roboto,
    shopee,
    openSans,
    ...rest
  } = props;

  const FONT_FAMILIES = Object.freeze({
    openSans: "open_sans",
    shopee: "shopee_font",
    roboto: "roboto",
  });

  const FONT_WEIGHTS = Object.freeze({
    bold: "_bold",
    semiBold: "_semi_bold",
    medium: "_medium",
    regular: "_regular",
  });

  const [FontFamily, setFontFamily] = useState(FONT_FAMILIES.roboto);
  const [FontWeight, setFontWeight] = useState(FONT_WEIGHTS.regular);

  useEffect(() => {
    const determineFontFamily = () => {
      Object.keys(props).forEach((key) => {
        const lowerKey = key.toLowerCase();
        if (Object.keys(FONT_FAMILIES).includes(lowerKey)) {
          if (props[key] === true) {
            setFontFamily(FONT_FAMILIES[lowerKey]);
          }
        }
      });
    };

    const determineFontWeight = () => {
      Object.keys(props).forEach((key) => {
        const lowerKey = key.toLowerCase();
        if (Object.keys(FONT_WEIGHTS).includes(lowerKey)) {
          if (props[key] === true) {
            setFontWeight(FONT_WEIGHTS[lowerKey]);
          }
        }
      });
    };
    determineFontFamily();

    determineFontWeight();
  }, [FONT_FAMILIES, FONT_WEIGHTS, props]);

  return (
    <span
      className={`
				typographyRoot
				${FontFamily}${FontWeight}
				${className}
			`}
      {...rest}
    >
      {props.children}
    </span>
  );
};

export const Headline = (props) => {
  const { className, h1, h2, ...rest } = props;

  const DEFAULT_HEADER_PREPEND = "-h";
  const DEFAULT_HEADER = "1";

  const [headerExtension, setHeaderExtension] = useState(
    DEFAULT_HEADER_PREPEND + DEFAULT_HEADER
  );

  useEffect(() => {
    let ext = DEFAULT_HEADER;
    if (h2) ext = "2";
    else if (h1) ext = "1";
    setHeaderExtension(DEFAULT_HEADER_PREPEND + ext);
  }, [h1, h2]);

  return (
    <Text
      className={`typographyHeadline${headerExtension} ${className}`}
      {...rest}
    >
      {props.children}
    </Text>
  );
};

export const Title = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographyTitle ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};

export const Subtitle = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographySubtitle ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};

export const Body1 = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographyBody1 ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};

export const Footnote = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographyFootnote ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};

export const Menu = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographyMenu ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};

export const Selection = (props) => {
  const { className, ...rest } = props;

  return (
    <Text className={`typographySelection ${className}`} {...rest}>
      {props.children}
    </Text>
  );
};
